import {IController, IModule, IOnChangesObject, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import _ from "lodash";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";
import {Kontekst} from "felles/tjenester/Kontekst";
import {ModelloppdateringTjeneste} from "../../../../tjenester/ModelloppdateringTjeneste";
import {AvstemningRessurs} from "felles/tjenester/ressurser/AvstemningRessurs";
import {RedigerAvstemningDialog} from "../../modale/redigerAvstemningDialog/redigerAvstemningDialog";
import {BeslutningTjeneste} from "../../BeslutningTjeneste";
import {Dialog} from "../../../../tjenester/Dialog";

const css = require('./avstemning.scss');

export class AvstemningKontroller implements IController {

    static eventer = {
        stengAvstemning: 'AvstemningKontroller.eventer.stengAvstemning'
    };

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmMoeteAvstemning', {
                bindings: {avstemning: '<', avstemningsstatus: '<', moeteId: '<', moeteLaastForRedigering: '<', visKunResultat: '<'},
                controller: AvstemningKontroller.forInjisering(),
                template: require('./avstemning.html')
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            AvstemningRessurs.regNavn,
            RedigerAvstemningDialog.regNavn,
            BeslutningTjeneste.regNavn,
            Dialog.regNavn,
            MeldingTilBruker.regNavn,
            ModelloppdateringTjeneste.regNavn,
            regNavn.gettext.gettextCatalog,
            Kontekst.regNavn,
            AvstemningKontroller
        ]
    }

    constructor(private $scope: IScope,
                private avstemningRessurs:AvstemningRessurs,
                private redigeravstemningDialog: RedigerAvstemningDialog,
                private beslutningTjeneste: BeslutningTjeneste,
                private dialog: Dialog,
                private meldingTilBruker: MeldingTilBruker,
                private modelloppdatering: ModelloppdateringTjeneste,
                private gettextCatalog: gettextCatalog,
                private kontekst: Kontekst) {
        this.lyttTilStengAvstemningEvent();

        this.lyttTilMøteAvstemningÅpnet();
        this.lyttTilMøteAvstemningStengt();
        this.lyttTilAvstemningOppdatert();
        this.lyttTilMøtedeltakerAvstemningsresultatEndret();
        this.lyttTilMøtedeltakerAvstemningsresultatNullstilt();
        this.lyttTilMøtedeltakereOppdatert();
        this.lyttTilAvstemningÅpnet();
        this.lyttTilAvstemningStengt();
    }

    avstemning: l.AvstemningMedResultatModell; //settes via bindings/$onChanges
    avstemningsstatus: l.AvstemningsstatusModell; //settes via bindings/$onChanges
    moeteId: string; //settes via bindings/$onChanges
    moeteLaastForRedigering: boolean; //settes via bindings/$onChanges
    visKunResultat: boolean; //settes via bindings/$onChanges

    medlemHarSkriveRolle = false;
    visAntallStemmerAvgitt = false;

    valgtAlternativ:l.AvstemningsalternativModell;
    initieltValgtAlternativ:l.AvstemningsalternativModell;
    harIkkeAvgittStemme = false;
    erVisStemmeresultat = false;
    brukerKanStemme = false;

    private ignorerNesteAvstemningsresultatOppdatering = false;

    avstemningKanRedigeres(){
        return !this.moeteLaastForRedigering &&
            this.medlemHarSkriveRolle &&
            !this.avstemning.erAapenForAvstemning &&
            !_(this.avstemning.avstemningsalternativer).some(alternativ => alternativ.antallStemmer >0)
    }

    rediger(){
        this.redigeravstemningDialog.visRedigerAvstemningDialog(this.avstemning)
            .then((oppdatertModell:l.AvstemningMedResultatModell) => {
                this.settAvstemningsModell(oppdatertModell);
            });
    }

    slett() {
        this.avstemningRessurs.slett(this.avstemning.id).$promise
          .then(any=> this.modelloppdatering.broadcastLokalSlettetAvstemning(this.avstemning.id));
    }

    nullstillAvgitteStemmer(){
        this.avstemningRessurs.nullstillAvgitteStemmer(this.avstemning.id).$promise
            .then(avstemningModell => {
                this.settAvstemningsModell(avstemningModell);
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Stemmegivning på avstemning har blitt nullstilt"));
            });
    }

    aapneForAvstemning(){
        this.avstemningRessurs.åpneForAvstemning(this.avstemning.id).$promise
            .then(avstemningModell => {
                this.settAvstemningsModell(avstemningModell);
                this.modelloppdatering.broadcastLokalAvstemningÅpnet(this.avstemning);
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Det er nå åpnet for stemmegivning på avstemning"));
            });
    }

    stengeForAvstemning(){
        this.avstemningRessurs.stengForAvstemning(this.avstemning.id).$promise
            .then(avstemningModell => {
                this.settAvstemningsModell(avstemningModell);
                this.modelloppdatering.broadcastLokalAvstemningStengt(this.avstemning);
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Det er nå lukket for stemmegivning på avstemning"));
            });
    }

    opprettBeslutning() {
        this.beslutningTjeneste.visNyBeslutningDialogMedAvstemningSomMal(this.avstemning, this.avstemningsstatus);
    }

    pieTooltip(data: { id: string, value: number }) {
        const totalt = this.avstemningsstatus.antallStemmeberettigedeDeltakere;
        return data.id == 'andel' ?
            this.gettextCatalog.getString('{{antall}} av {{totalt}} stemmeberettigede har stemt', {antall: data.value, totalt: totalt}) :
            this.gettextCatalog.getString('{{antall}} av {{totalt}} stemmeberettigede har ikke stemt', {antall: data.value, totalt: totalt});
    }

    erValgEndret() {
        //console.debug('erValgEndret', this.initieltValgtAlternativ, this.valgtAlternativ);
        if (_.isNil(this.initieltValgtAlternativ) && _.isNil(this.valgtAlternativ)) return false;
        return this.initieltValgtAlternativ?.id !== this.valgtAlternativ?.id;
    }

    nullstillAvgittStemmeMedBekreftelse(){
        this.dialog.confirm(
            ///dialogtittel for dialog ved nullstilling av avstemningsresultat for møte
            this.gettextCatalog.getString('Slett avgitt stemme'),
            ///dialoginnhold for dialog ved nullstilling av avstemningsresultat for møte
            this.gettextCatalog.getString('Du kan frem til avstemningen lukkes endre din stemme'),
            ///ok-knapp i dialog ved nullstilling av avstemningsresultat for møte
            this.gettextCatalog.getString('Slett'),
            ///avbryt-knapp i dialog ved nullstilling av avstemningsresultat for møte
            this.gettextCatalog.getString('Avbryt'))
            .then(() => {
                this.nullstillAvgittStemme();
            });
    }

    avgiStemme(){
        this.ignorerNesteAvstemningsresultatOppdatering = true; //for å hindre unødvendig trigging av oppdaterAvstemningsresultat()
        this.avstemningRessurs.avgiStemme(this.avstemning.id, _.isNil(this.valgtAlternativ) ? null : this.valgtAlternativ.id).$promise
            .then(avstemning => {
                this.settAvstemningsModell(avstemning);
                this.modelloppdatering.broadcastLokalMøtedeltakerAvstemningsresultatEndret(this.medlem().id, this.avstemning.id, this.moeteId)
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Din stemme er registrert'));
            });
    }

    $onChanges(endringer: IOnChangesObject): void {
        //console.debug('ENDRINGER avstemningsalternativer', endringer);
        dersomChangesInneholder(endringer, 'avstemning', avstemning => this.settAvstemningsModell(avstemning));
        dersomChangesInneholder(endringer, 'moeteLaastForRedigering', moeteLaastForRedigering => this.settAvstemningsModell(this.avstemning));
        dersomChangesInneholder(endringer, 'avstemningsstatus', moeteLaastForRedigering => this.settAvstemningsModell(this.avstemning, true));
    }

    //hjelpemetoder

    private settAvstemningsModell(avstemning: l.AvstemningMedResultatModell, bevarBrukersValg = false) {
        //console.debug('### settAvstemningsModell', avstemning);
        const aktivtValg = this.valgtAlternativ;
        if (_.isNil(this.avstemning)) this.avstemning = avstemning;
        _.assign(this.avstemning, avstemning); //kopier til eksisterende objekt slik at omverden også får med seg endringene.
        this.medlemHarSkriveRolle = this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.avstemning.eiendeGruppeId);
        this.visAntallStemmerAvgitt = this.medlemHarSkriveRolle && !_.isNil(this.avstemningsstatus);

        this.valgtAlternativ = _(this.avstemning.avstemningsalternativer).find(alternativ => alternativ.erDeltakersValg);
        this.initieltValgtAlternativ = this.valgtAlternativ;
        this.erVisStemmeresultat = this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.tilgangIkkePublisert, this.avstemning.eiendeGruppeId) || !this.avstemning.erAapenForAvstemning;
        this.brukerKanStemme = this.avstemning.erAapenForAvstemning && this.avstemning.deltakerErStemmeberettiget;
        this.harIkkeAvgittStemme = this.brukerKanStemme && _.isNil(this.initieltValgtAlternativ);

        //for at ikke brukers valg skal bli borte som følge av oppdateringen
        if (bevarBrukersValg) this.valgtAlternativ = _(this.avstemning.avstemningsalternativer).find(alternativ => aktivtValg?.id === alternativ.id);
    }

    private oppdaterAvstemningsresultat(bevarBrukersValg = false) {
        this.avstemningRessurs.hent(this.avstemning.id).$promise
            .then((oppdatertAvstemning: l.AvstemningMedResultatModell) => {
                this.settAvstemningsModell(oppdatertAvstemning, bevarBrukersValg);
            });
    }

    private nullstillAvgittStemme(){
        this.valgtAlternativ = null;
        this.ignorerNesteAvstemningsresultatOppdatering = true; //for å hindre unødvendig trigging av oppdaterAvstemningsresultat()
        this.avstemningRessurs.avgiStemme(this.avstemning.id, null).$promise
            .then(avstemning => {
                this.settAvstemningsModell(avstemning);
                this.modelloppdatering.broadcastLokalMøtedeltakerAvstemningsresultatNullstilt(this.medlem().id, this.moeteId);
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Din stemme har blitt slettet'));
            });
    }

    private lyttTilStengAvstemningEvent() {
        this.$scope.$on(AvstemningKontroller.eventer.stengAvstemning, (event, avstemningId) => {
            if(this.avstemning.id === avstemningId) this.stengeForAvstemning();
        });
    }

    private medlem() {
        return this.kontekst.medlemRepresentasjonTilknyttet(this.avstemning.eiendeGruppeId);
    }

    //modelloppdateringslyttere

    private lyttTilMøteAvstemningÅpnet() {
        this.modelloppdatering.vedMøteAvstemningÅpnet(
            møteId => this.moeteId == møteId,
            this.$scope,
            møteId => {
                this.oppdaterAvstemningsresultat();
            });
    }

    private lyttTilMøteAvstemningStengt() {
        this.modelloppdatering.vedMøteAvstemningStengt(
            møteId => this.moeteId == møteId,
            this.$scope,
            møteId => {
                this.oppdaterAvstemningsresultat();
            });
    }

    private lyttTilAvstemningOppdatert() {
        this.modelloppdatering.vedOppdatertAvstemning(
            oppdatert => this.avstemning.id == oppdatert.avstemningId,
            this.$scope,
            oppdatert => {
                this.oppdaterAvstemningsresultat();
                // tar bort denne meldingen, ellerså må den legges inn i metoden som henter. Vil ikke at meldingen skal komme før det er oppdatert.
                //this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Avstemning oppdatert"));
            });
    }

    private lyttTilMøtedeltakerAvstemningsresultatEndret() {
        this.modelloppdatering.vedMøtedeltakerAvstemningsresultatEndret(
            info => this.avstemning.id == info.avstemningId && this.erVisStemmeresultat, //@todo
            this.$scope,
            info => {
                if (this.ignorerNesteAvstemningsresultatOppdatering){
                    this.ignorerNesteAvstemningsresultatOppdatering = false;
                    return;
                }
                this.oppdaterAvstemningsresultat(true);
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Avstemningsresultat oppdatert"));
            });
    }

    private lyttTilMøtedeltakerAvstemningsresultatNullstilt() {
        //@todo mangler avstemning id
        this.modelloppdatering.vedMøtedeltakerAvstemningsresultatNullstilt(
            info => this.moeteId == info.moeteId && this.erVisStemmeresultat,
            this.$scope,
            info => {
                this.oppdaterAvstemningsresultat();
                this.valgtAlternativ = null;
                this.initieltValgtAlternativ = null;
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Avgitte stemmer har blitt nullstilt"));
            });
    }

    private lyttTilMøtedeltakereOppdatert() {
        this.modelloppdatering.vedMøtedeltakereOppdatert(
          moeteId => this.moeteId == moeteId && this.erVisStemmeresultat,
            this.$scope,
            info => {
                this.oppdaterAvstemningsresultat(true);
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Stemmeberettigede deltakere har blitt endret"));
            });
    }

    private lyttTilAvstemningÅpnet() {
        this.modelloppdatering.vedAvstemningÅpnet(
            info => this.avstemning.id == info.avstemningId,
            this.$scope,
            info => {
                this.oppdaterAvstemningsresultat();
            });
    }

    private lyttTilAvstemningStengt() {
        this.modelloppdatering.vedAvstemningStengt(
            info => this.avstemning.id == info.avstemningId,
            this.$scope,
            info => {
                this.oppdaterAvstemningsresultat();
            });
    }

    //@todo lytt til avstemning stengt/åpnet  (skjer indirekte via avstemning.oppdatering event som trigger onchange)
    //endringer i alternativer? (skjer indirekte via avstemning.oppdatering event som trigger onchange)


}


